"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GlobalGuard", {
    enumerable: true,
    get: function() {
        return GlobalGuard;
    }
});
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _rxjs = require("rxjs");
const _jwtstrategy = require("~/strategies/jwt.strategy");
const _helpers = require("~/helpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let GlobalGuard = class GlobalGuard extends (0, _passport.AuthGuard)([
    'jwt'
]) {
    async canActivate(context) {
        var _req_headers;
        let result;
        const req = context.switchToHttp().getRequest();
        if ((_req_headers = req.headers) == null ? void 0 : _req_headers['xc-auth']) {
            try {
                result = await this.extractBoolVal(super.canActivate(context));
                if (result && req.context) {
                    req.context.user = {
                        id: req.user.id,
                        email: req.user.email,
                        email_verified: req.user.email_verified
                    };
                }
            } catch (e) {
                console.log(e);
            }
        }
        if (result) return true;
        if ((0, _helpers.getApiTokenFromHeader)(req)) {
            var _req_headers_authorization, _req_headers1;
            let canActivate = false;
            try {
                const guard = new ((0, _passport.AuthGuard)('authtoken'))(context);
                canActivate = await this.extractBoolVal(guard.canActivate(context));
            } catch (unused) {}
            // If API token validation failed and we have a Bearer token, try OAuth token validation
            if (!canActivate && ((_req_headers1 = req.headers) == null ? void 0 : (_req_headers_authorization = _req_headers1.authorization) == null ? void 0 : _req_headers_authorization.toLowerCase().startsWith('bearer '))) {
                try {
                    const oauthGuard = new ((0, _passport.AuthGuard)('oauth-token'))(context);
                    canActivate = await this.extractBoolVal(oauthGuard.canActivate(context));
                } catch (unused) {}
            }
            if (canActivate) {
                return this.authenticate(req, _extends({}, req.user, {
                    isAuthorized: true,
                    roles: req.user.roles
                }));
            }
        } else if (req.headers['xc-shared-base-id']) {
            let canActivate = false;
            try {
                const guard = new ((0, _passport.AuthGuard)('base-view'))(context);
                canActivate = await this.extractBoolVal(guard.canActivate(context));
            } catch (unused) {}
            if (canActivate) {
                return this.authenticate(req, _extends({}, req.user, {
                    isAuthorized: true,
                    isPublicBase: true
                }));
            }
        }
        // If JWT authentication fails, use the fallback strategy to set a default user
        return await this.authenticate(req);
    }
    async authenticate(req, user = {
        roles: {
            guest: true
        }
    }) {
        const u = await this.jwtStrategy.validate(req, user);
        req.user = u;
        if (req.context) {
            req.context.user = {
                id: req.user.id,
                email: req.user.email,
                email_verified: req.user.email_verified
            };
        }
        return true;
    }
    async extractBoolVal(canActivate) {
        if (canActivate instanceof _rxjs.Observable) {
            return (0, _rxjs.lastValueFrom)(canActivate);
        } else if (typeof canActivate === 'boolean' || canActivate instanceof Promise) {
            return canActivate;
        }
    }
    constructor(jwtStrategy){
        super(), this.jwtStrategy = jwtStrategy;
    }
};
GlobalGuard = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jwtstrategy.JwtStrategy === "undefined" ? Object : _jwtstrategy.JwtStrategy
    ])
], GlobalGuard);
